import { ECard } from 'pages/MainPage/blocks/HelpBlock/ulils/constants';

export const TYPE_ANALYTICS_RESULT = {
  [ECard.other]: 'others',
  [ECard.elk]: 'elk',
  [ECard.service]: 'services',
  [ECard.tariff]: 'tariffs',
  [ECard.product]: 'products',
};
